import React from 'react';
import SearchDoctorListItem from './SearchDoctorListItem';
import SearchArticleListItem from './SearchArticleListItem';
import SearchHospitalListItem from './SearchHospitalListItem';
import SearchAnnouncementListItem from './SearchAnnouncementListItem';
import SearchShortVideoListItem from './SearchShortVideoListItem';
import SearchArticlesVideoListItem from './SearchArticlesVideoListItem';

export default class SearchResultsList extends React.Component {

  hasResults() {
    return this.props.doctors.length > 0 ||
      this.props.articles.length > 0 ||
      this.props.hospitals.length > 0 ||
      this.props.announcements.length > 0 ||
      this.props.short_videos.length > 0 ||
      this.props.articles_videos.length > 0;
  }

  render() {
    return (
      <div
        className="search-results"
        id="autocomplete-items"
        onMouseEnter={() => { this.props.setPreventHideDropdown() }}
        onMouseLeave={() => { this.props.resetPreventHideDropdown() }}
      >
        <div className="search-results__link">
          <a href={`/en/search?q=${this.props.term}`}>
            <i className="fa fa-search"></i> Search for <strong>{this.props.term}</strong>
          </a>
        </div>

        {this.hasResults() ? this.renderResults() : this.renderEmpty()}
      </div>
    );
  }

  renderResults() {
    return (
      <div className="search-results__body">
        {this.renderSection('Doctors', 'fa-user-md', this.props.doctors, (doctor) => (
          <SearchDoctorListItem key={doctor.id} doctor={doctor} />
        ))}
        {this.renderSection('Hospitals', 'fa-hospital-o', this.props.hospitals, (hospital) => (
          <SearchHospitalListItem key={hospital.id} hospital={hospital} />
        ))}
        {this.renderSection('News & Events', 'fa-newspaper-o', this.props.announcements, (announcement) => (
          <SearchAnnouncementListItem key={announcement.id} announcement={announcement} />
        ))}
        {this.renderSection('Articles', 'fa-file-text-o', this.props.articles, (article) => (
          <SearchArticleListItem key={article.id} article={article} />
        ))}
        {this.renderSection('Short Videos', 'fa-play-circle-o', this.props.short_videos, (video) => (
          <SearchShortVideoListItem key={video.id} video={video} />
        ))}
        {this.renderSection('Articles Videos', 'fa-video-camera', this.props.articles_videos, (video) => (
          <SearchArticlesVideoListItem key={video.id} video={video} />
        ))}
      </div>
    );
  }

  renderSection(title, icon, items, renderItem) {
    if (items.length === 0) return null;

    return (
      <div className="search-results__section">
        <div className="search-results__section-header">
          <i className={`fa ${icon}`}></i>
          <span>{title}</span>
        </div>
        <div className="search-results__items">
          {items.map(renderItem)}
        </div>
      </div>
    );
  }

  renderEmpty() {
    return (
      <div className="search-results__empty">
        <i className="fa fa-search"></i>
        <p>No results found for <strong>"{this.props.term}"</strong></p>
        <span>Try a different search term</span>
      </div>
    );
  }
}
